import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { InitService } from './soma-reset-password-app/services/init.service';
import { TENANT } from './soma-reset-password-app/shared/interfaces/tenant.interface';
import { TenantConfiguration } from './soma-reset-password-app/shared/interfaces/tenantConfiguration.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = '';

  isReset: boolean = false;
  isDeleteAccount: boolean = false;
  isEnrollment: boolean = false;
  tenantConfiguration!: TenantConfiguration;

  constructor(
    private router: Router,
    private initService: InitService,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          if (router.url.includes('reset-password')) {
            this.isReset = true
          }
          else if (router.url.includes('deleteAccount')) {
            this.isDeleteAccount = true
          }
          else {
            this.isEnrollment = true;
          }
        }
      }
    )
  }

  ngOnInit(): void {
    this.initializeApp();
  }

  initializeApp() {
    this.setTheme(this.initService.tenantConfigurations);
  }

  setTheme(tenantConfiguration: TenantConfiguration) {
    document.documentElement.style.setProperty('--color-primary', tenantConfiguration.primaryColor);
    document.documentElement.style.setProperty('--color-secondary', tenantConfiguration.secondaryColor);
    document.documentElement.style.setProperty('--color-tertiary', tenantConfiguration.tertiaryColor);
    document.documentElement.style.setProperty('--color-button-text', tenantConfiguration.buttonTextColor);

    if (tenantConfiguration.imageUrl != '')
      document.documentElement.style.setProperty('--image-url', `url('${tenantConfiguration.imageUrl}')`);

    this.tenantConfiguration = tenantConfiguration;

    TENANT.ID = this.tenantConfiguration.tenantId;
    TENANT.TENANT_NAME = this.tenantConfiguration.name;

    // Atualizar título da página
    if (tenantConfiguration.name) {
      this.titleService.setTitle(tenantConfiguration.name);
    }

    // Atualizar ícone da página
    if (tenantConfiguration.iconUrl) {
      this.updateFavicon(tenantConfiguration.iconUrl);
    }
  }

  private updateFavicon(iconUrl: string): void {
    // Remove o favicon existente
    const existingFavicon = this.document.querySelector("link[rel*='icon']");
    if (existingFavicon) {
      existingFavicon.remove();
    }

    // Cria e adiciona o novo favicon
    const link: HTMLLinkElement = this.document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = iconUrl;
    this.document.head.appendChild(link);
  }

}
